import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Admin Redux States
import { GET_ADMINS, ADD_NEW_ADMIN, UPDATE_ADMIN } from "./actionType";

import {
  adminApiResponseSuccess,
  adminApiResponseError,
  addAdminFail,
  addAdminSuccess,
  updateAdminSuccess,
  updateAdminFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getAdmins as getAdminsApi,
  addNewAdmin,
  updateAdmin,
} from "../../helpers/fakebackend_helper";
import axios from "axios";

function* getAdmins() {
  try {
    const response = yield call(getAdminsApi);
    // console.log( "response: ", response );
    yield put(adminApiResponseSuccess(GET_ADMINS, response));
  } catch (error) {
    yield put(adminApiResponseError(GET_ADMINS, error));
  }
}

function* onUpdateAdmin({ payload: admin }) {
  // console.log( admin );
  try {
    const response = yield call(updateAdmin, admin);
    // console.log( response );
    yield put(updateAdminSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(updateAdminFail(error));
  }
}

function* onAddNewAdmin({ payload: admin }) {
  try {
    // console.log( admin );
    const response = yield call(addNewAdmin, admin);
    yield put(addAdminSuccess(response));
  } catch (error) {
    yield put(addAdminFail(error));
  }
}

export function* watchGetAdmins() {
  yield takeEvery(GET_ADMINS, getAdmins);
}

export function* watchUpdateAdmin() {
  yield takeEvery(UPDATE_ADMIN, onUpdateAdmin);
}

export function* watchAddNewAdmin() {
  yield takeEvery(ADD_NEW_ADMIN, onAddNewAdmin);
}

function* adminSaga() {
  yield all([
    fork(watchGetAdmins),
    fork(watchUpdateAdmin),
    fork(watchAddNewAdmin),
  ]);
}

export default adminSaga;
